import React, { useState } from "react";
import Gelato from "./Gelato";
import axios from "axios";
import data from "../fakeData";

//const url = "https://react--course-api.herokuapp.com/api/v1/data/gelateria";
const url = "https://react-corso-api.netlify.app/.netlify/functions/gelateria";

const Menu = () => {
  //Loading state for data fetching
  const [isLoading, setisLoading] = useState(true);

  //Error handling state
  const [isError, setIsError] = useState(false);

  // tutti i prodotti
  const [prodotti, setProdotti] = React.useState();

  //active BTN selector
  const [selected, setSelected] = useState(0);

  //products filtered from theprodotti state
  const [filterProducts, setFilterProducts] = useState();
  //console.log(prodotti);

  //Categorie di prodotti
  const [categorie, setCategorie] = useState([])
  
  
  // const categorie = Array.from(new Set(prodotti.map((el) => el.categoria)));
  // //console.log(categorie);
  // categorie.unshift("all");
  


  const filtraProdotti = (categoria, index)=>{
    setSelected(index);
    if(categoria === 'all'){
      // setProdotti(data);
       setFilterProducts(prodotti); //prodotti o data?
    }
    else{
     // setProdotti(prodotti.filter(el => el.categoria === categoria ? el : ''));
     //const prodottiFiltrati =
      setFilterProducts(prodotti.filter((el) => el.categoria === categoria ? el : ''));
    }
  };


  React.useEffect(()=>{

    //funzione eseguita immediatamente 
    (async()=>{
      setisLoading(true);
      setIsError(false);
      try {
        const response = await axios.get(url);
        //console.log(response.data);
        
        setProdotti(response.data.data.default);
        setFilterProducts(response.data.data.default);

        //ottengo array di elementi non ripetibili
        const nuoveCategorie = Array.from(
          new Set(response.data.data.default.map((el)=>el.categoria))
        );

        //Aggiungo all'inizio termine all
        nuoveCategorie.unshift("all");
        setCategorie(nuoveCategorie);

        //termino caricamento
        setisLoading(false);
        setIsError(false);
      } catch (error) {
        console.log(error);
        setisLoading(false);
        setIsError(true);
      }
    })();
  }, []);
  return  (
    <div className="container">
        <h4 style={{textAlign: 'center', textTransform: "uppercase"}}>
          Le nostre scelte
        </h4>
        { //se non sto caricando e non ci sono errori
          !isLoading && !isError ? ( 
          <>
             <div className="lista-categorie">
             {
               categorie.map((categoria, index ) =>(
                <button 
                  key={index} 
                  className={`btn btn-selector ${index === selected && 'active'}`}
                  data-categoria={categoria}
                onClick={() => filtraProdotti(categoria, index)}>
                  {categoria}
                </button>
              )
            )
         };
        </div>
      <hr />
      <div className="vetrina">
        {
          // prodotti.map(el => <Gelato key={el.id} {...el} />)
          filterProducts.map((el) => <Gelato key={el.id} {...el} />)
        }
      </div>
          </>
          ): //se non sto caricando ma sono presenti errori
          !isLoading && isError ? (
          <h4 style={{ 
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)'

           }}>
            Error...
            </h4>
            ) : (
            <h4 style={{ 
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)'
           }}
           >
            Loading...
            </h4>
            )
        }
       </div>       
      );
    };

export default Menu;
